/* eslint-disable node/no-callback-literal */
import { i18n } from '@/plugins/i18n/i18n'
import { CssValidator } from '@/utils/cssValidator'

export const defaultRangeMax = 9999999
const newebpayTrustMerchantIdPrefixes = ['HTM', 'HTW']

// == Check Logic == //
//= > 手機號碼檢查
export function checkPhone (rule, value, callback) {
  const home = /^0\d{1,9}$/
  const phone = /^09\d{8}$/
  const international = /^\+\d{1,4}\s?\d{1,9}$/ // Matches a '+' sign followed by 1 to 4 digits, an optional space, and then 9 digits
  if (value === '') return callback()

  if (rule.home && rule.phone) {
    if (!phone.test(value) && !home.test(value) && !international.test(value)) {
      console.log('here')
      return callback(new Error(i18n.t('validation.checkPhone.text')))
    } else {
      return callback()
    }
  } else if (!phone.test(value) && !international.test(value)) {
    return callback(new Error(i18n.t('validation.checkPhone.text')))
  } else {
    return callback()
  }
}

//= > 電子信箱檢查
export function checkEmail (rule, value, callback) {
  if (!rule.required && value === '') return callback()
  const reg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (!reg.test(value)) {
    return callback(new Error('請輸入正確的電子信箱'))
  } else {
    return callback()
  }
}

export function checkArray (rule, value, callback) {
  if (value.length === 0) {
    return callback(new Error(i18n.t('validation.checkArray.text')))
  } else {
    return callback()
  }
}

//= > 網址檢查
export function checkURL (rule, value, callback) {
  const reg = /^https?:\/{2}[^\s]*/gm
  if (!value) return callback()
  if (!reg.test(value)) {
    return callback(new Error(i18n.t('validation.checkURL.text')))
  } else {
    return callback()
  }
}
//= > 英文網址檢查
export function checkEnglishURL (rule, value, callback) {
  const reg = /^[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=]+$/
  if (!value) return callback()
  if (!reg.test(value)) {
    return callback(new Error('請輸入僅包含英文字符和符號的 URL'))
  } else {
    return callback()
  }
}
export function checkDigitAndRange (rule, value, callback) {
  const reg = /^-?[0-9]*$/
  const min = rule.min
  const max = rule.max
  // if (!Number.isNaN(Number(value))) return callback()
  if (!reg.test(value)) {
    return callback(new Error(i18n.t('validation.checkDigit.text')))
  } else {
    if (value > max || value < min) {
      return callback(new Error(i18n.t('validation.checkDigitAndRange.text', { min, max })))
    } else return callback()
  }
}

//= > 檢查
export function checkDigit (rule, value, callback) {
  const reg = /^-?[0-9]*$/
  if (!Number.isNaN(Number(value))) return callback()
  if (!reg.test(value)) {
    return callback(new Error(i18n.t('validation.checkDigit2.text')))
  } else {
    return callback()
  }
}

//= > 檢查
export function checkLength (rule, value, callback) {
  // TODO 排除符號
  const min = rule.min
  const max = rule.max

  if (value.length < min) {
    return callback(new Error(i18n.t('validation.checkLength.text', { min, max })))
  } else if (value.length > max) {
    return callback(new Error(i18n.t('validation.checkLength.text', { min, max })))
  } else return callback()
}

export function checkArrayLength (rule, value, callback) {
  const max = rule.max
  if (value.length > max) {
    return callback(new Error(i18n.t('validation.checkArrayLength.text', { max })))
  } else return callback()
}
export function checkArrayMinLength (rule, value, callback) {
  const min = rule.min
  if (value.length < min) {
    return callback(new Error(i18n.t('validation.checkArrayMinLength.text', { min })))
  } else return callback()
}
export function checkMaxNumber (rule, value, callback) {
  const max = rule.max
  if (value > max) {
    return callback(new Error(i18n.t('validation.checkMaxNumber.text', { max })))
  } else return callback()
}
export function checkDomain (rule, value, callback) {
  const reg = /^[0-9a-z\\-]*$/
  if (!reg.test(value)) {
    return callback(new Error(i18n.t('validation.checkDomain.text')))
  } else {
    return callback()
  }
}

export function checkInteger (rule, value, callback) {
  if (Number.isInteger(Number(value))) {
    return callback()
  } else {
    return callback(new Error(i18n.t('validation.checkInteger.text')))
  }
}

export const noSymbolCheck = (rule, value, callback) => {
  const pattern = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/
  const noPass = pattern.test(value)
  if (noPass) return callback(new Error(i18n.t('validation.noSymbolCheck.text')))
  return callback()
}

// TODO 數值範圍
export function checkRange (rule, value, callback) {
  const min = rule.min
  const max = rule.max

  if (!max) {
    if (value < min) return callback(new Error(i18n.t('validation.checkRange.text', { min })))
  }

  if (value < min) return callback(new Error(i18n.t('validation.checkDigitAndRange.text', { min, max })))
  else if (value > max) {
    return callback(new Error(i18n.t('validation.checkDigitAndRange.text', { min, max })))
  } else return callback()
}

// == Rules Export == //

// only show error message
export const noSameTimeRules = (msg = i18n.t('validation.noSameTimeRules.default.text')) => {
  return { message: msg, trigger: ['change', 'blur'] }
}
//= > No Empty
export const noEmptyRules = (msg = i18n.t('validation.noEmptyRules.default.text'), change = false) => {
  // if (!change) return { required: true, message: msg, trigger: ['blur'] }
  // if (change) return { required: true, message: msg, trigger: ['change'] }
  return { required: true, message: msg, trigger: ['change', 'blur'] }
}
export const newebpayMerchantIdPrefixRules = (allowTrustPrefixes = false) => {
  const message = allowTrustPrefixes
    ? 'MerchantID 前綴與所選接口類型不符，藍新類信託只允許填入 HTM 或 HTW 開頭的 MerchantID'
    : 'MerchantID 前綴與所選接口類型不符，一般藍新不可填入 HTM 或 HTW 開頭的 MerchantID'

  return {
    trigger: ['change', 'blur'],
    validator: (rule, value, callback) => {
      if (!value) {
        return callback()
      }

      const normalizedMerchantId = value.trim().toUpperCase()
      const trustMerchantId = newebpayTrustMerchantIdPrefixes.some((prefix) => normalizedMerchantId.startsWith(prefix))

      if (allowTrustPrefixes && !trustMerchantId) {
        return callback(new Error(message))
      }

      if (!allowTrustPrefixes && trustMerchantId) {
        return callback(new Error(message))
      }

      return callback()
    },
  }
}
export const noEmptyArrayRules = () => {
  return { required: true, validator: checkArray, trigger: ['change', 'blur'] }
}
export const promisePeriodDaysRules = (min, max) => {
  return { min: min, max: max, validator: checkDigitAndRange, trigger: ['change', 'blur'] }
}
//= > Username
export const usernameRules = (required = true, msg = i18n.t('validation.usernameRules.default.text')) => {
  return [{ required: required, message: msg, trigger: 'blur' }]
}

//= > Phone
export const phoneRules = (required = true, phone = true, home = false) => {
  return {
    required: required,
    phone,
    home,
    validator: checkPhone,
    trigger: 'blur',
  }
}

//= > Email
export const emailRules = (required = true) => {
  return { required: required, validator: checkEmail, trigger: 'blur' }
}

export const emailRulesNoRequired = (msg) => {
  return { type: 'email', message: i18n.t('validation.emailRulesNoRequired.text') || msg, trigger: 'blur' }
}

//= > URL
export const urlRules = () => {
  return { validator: checkURL, trigger: 'blur' }
}
// =>  English URL
export const englishUrlRules = () => {
  return { validator: checkEnglishURL, trigger: 'blur' }
}
//= > Digit
export const isDigitRules = (required = true) => {
  return { required: required, validator: checkDigit, trigger: 'blur' }
}

//= > Length
export const lengthRules = (min, max) => {
  return { min: min, max: max, validator: checkLength, trigger: 'blur' }
}
export const maxExcludeHtmlRules = (max, msg) => {
  return {
    max,
    message: msg || i18n.t('validation.maxRules.text', { max }),
    validator: checkMaxExcludeHtml,
    trigger: ['change', 'blur'],
  }
}
export const maxRules = (max, msg) => {
  return { max: max, message: msg || i18n.t('validation.maxRules.text', { max }), trigger: 'blur' }
}
export const maxNumberRules = (max, msg) => {
  return { max: max, message: msg || i18n.t('validation.checkMaxNumber.text', { max }), validator: checkMaxNumber, trigger: ['blur', 'change', 'input'] }
}
export const maxArrayRules = (max, msg) => {
  return { max: max, message: msg || i18n.t('validation.checkArrayLength.tex', { max }), validator: checkArrayLength, trigger: 'change' }
}
export const minArrayRules = (min, msg) => {
  return { min: min, message: msg || `至少 ${min} 組`, validator: checkArrayMinLength, trigger: 'change' }
}

export const noSymbolRules = () => {
  return { validator: noSymbolCheck, trigger: 'blur' }
}

export const rangeRules = (min = 0, max = defaultRangeMax) => {
  return { min: min, max: max, validator: checkRange, trigger: 'blur' }
}
export const minRules = (min = 0, msg) => {
  return { min: min, message: msg, validator: checkRange, trigger: 'blur' }
}

//= > No Empty
export const changeEventRules = (msg = i18n.t('validation.noEmptyRules.default.text')) => {
  return { required: true, message: msg, trigger: 'change' }
}

//= > No Empty
export const domainRules = (msg = i18n.t('validation.checkDomain.text')) => {
  return { validator: checkDomain, message: msg, trigger: 'blur' }
}

//= > Integer
export const integerRules = (msg = i18n.t('validation.checkInteger.text')) => {
  return { validator: checkInteger, message: msg, trigger: 'blur' }
}

//= > checkTimeInterval
export const noEmptyTimeInterval = () => {
  return {
    trigger: 'change',
    validator: (rule, value, callback) => {
      if (value.length === 0) return callback(i18n.t('validation.noEmptyTimeInterval.text'))

      const hasEmptyTime = value.some((time) => !time.start || !time.end)
      if (hasEmptyTime) return callback(i18n.t('validation.noEmptyTimeInterval.text'))

      callback()
    },
  }
}
export const noEmptyDateTimeInterval = () => {
  return {
    trigger: 'change',
    validator: (rule, value, callback) => {
      const hasEmptyTime = value.some((time) => {
        if (!time) return true
        return !time[0] || !time[1]
      })
      if (hasEmptyTime) return callback(i18n.t('validation.noEmptyTimeInterval.text'))

      callback()
    },
  }
}

export const noEmptyDateTimeRangeInterval = () => {
  return {
    trigger: 'change',
    validator: (rule, value, callback) => {
      const hasEmptyTime = value.some((time) => !time.date || !time.timeEnd || !time.timeStart)
      if (hasEmptyTime) return callback(i18n.t('validation.noEmptyTimeInterval.text'))

      callback()
    },
  }
}

export const noEmptyWeekRangeInterval = () => {
  return {
    trigger: 'change',
    validator: (rule, value, callback) => {
      const hasEmptyTime = value.some((time) => time.week === null || !time.timeEnd || !time.timeStart)
      if (hasEmptyTime) return callback(i18n.t('validation.noEmptyTimeInterval.text'))

      callback()
    },
  }
}

export const noPastDate = () => {
  return {
    trigger: ['change', 'blur'],
    validator: (rule, value, callback) => {
      console.log(value)
      const hasPastDate = new Date(value) < new Date()
      if (hasPastDate) return callback('不可選擇過去時間')

      callback()
    },
  }
}

export const noBeforeStartDate = (startDate) => {
  return {
    trigger: ['change', 'blur'],
    validator: (rule, value, callback) => {
      const hasPastDate = new Date(value) <= new Date(startDate)
      if (hasPastDate) return callback('恢復訂閱日期須晚於暫停起始日期')

      callback()
    },
  }
}

export const CVSSenderRules = () => {
  return {
    validator: checkCVSSenderName,
    trigger: 'blur',
  }
}

// -- Feature validator
export const featureValidator = (featureList, feature) => {
  let use = false
  for (const item of Object.keys(featureList)) {
    if (feature === item) {
      use = featureList[item]
    }
    const row = feature.split('.')
    while (row.length > 0) {
      row.pop()
      if ([...row, '*'].join('.') === item) use = featureList[item]
    }
  }

  return use
}

// 物流收件人名稱長度檢查
export const checkCVSSenderName = (rule, value, callback) => {
  if (/^[a-zA-Z]+$/.test(value)) {
    if (value.length < 4) {
      return callback(new Error('英文至少 4 字'))
    }
    if (value.length > 10) {
      return callback(new Error('英文最多 10 字'))
    }
    return callback()
  }
  if (/^[\u4e00-\u9fa5]+$/.test(value)) {
    if (value.length < 2) {
      return callback(new Error('中文至少 2 字'))
    }
    if (value.length > 5) {
      return callback(new Error('中文最多 5 字'))
    }
    return callback()
  }
  return callback(new Error('請輸入中文或英文'))
}

export const minLengthRules = (min, msg) => {
  return { min: min, message: msg || `密碼長度至少 ${min} 碼`, trigger: 'blur' }
}

// 須包含至少一個英文大寫
export const atLeastOneUpperCaseRules = () => {
  return {
    required: true,
    pattern: /^(?=.*[A-Z]).{1,}$/,
    message: i18n.t('validation.passwordRules.atLeastOneUpperCase.text'),
    trigger: 'blur',
  }
}

// 須包含至少一個英文小寫
export const atLeastOneLowerCaseRules = () => {
  return {
    required: true,
    pattern: /^(?=.*[a-z]).{1,}$/,
    message: i18n.t('validation.passwordRules.atLeastOneLowerCase.text'),
    trigger: 'blur',
  }
}

// 須包含至少一個數字
export const atLeastOneNumberRules = () => {
  return {
    required: true,
    pattern: /^(?=.*\d).{1,}$/,
    message: i18n.t('validation.passwordRules.atLeastOneNumber.text'),
    trigger: 'blur',
  }
}

// 須包含至少一個特殊符號 (/ < > * @ ! % ^ )
export const atLeastOneSpecialCharRules = () => {
  return {
    required: true,
    pattern: /^(?=.*[/<>*@!%^]).{1,}$/,
    message: i18n.t('validation.passwordRules.atLeastOneSpecialChar.text'),
    trigger: 'blur',
  }
}

// 大寫英文和數字
export const upperCaseAndNumberRules = () => {
  return {
    pattern: /^[A-Z0-9]+$/,
    message: '請輸入大寫英文和數字',
    trigger: 'blur',
  }
}

// 車牌 (大寫英文和數字，必須包含連字號)
export const licensePlateRules = () => {
  return {
    pattern: /^[A-Z0-9]+-[A-Z0-9]+$/,
    message: '請輸入正確的車牌格式，例如： ABC-1234',
    trigger: 'blur',
  }
}

// 車牌前綴 (大寫英文和數字)
export const licensePlatePrefixRules = () => {
  return {
    pattern: /^[A-Z0-9]+$/,
    message: '請輸入大寫英文和數字',
    trigger: 'blur',
  }
}

// 車牌後綴 (大寫英文和數字)
export const licensePlateSuffixRules = () => {
  return {
    pattern: /^[A-Z0-9]+$/,
    message: '請輸入大寫英文和數字',
    trigger: 'blur',
  }
}

// 大寫或小寫英文和數字
export const upperOrLowerCaseAndNumberRules = () => {
  return {
    pattern: /^[A-Za-z0-9]+$/,
    message: '請輸入英文和數字',
    trigger: 'blur',
  }
}

export const checkMaxExcludeHtml = (rule, value, callback) => {
  const strippedValue = value.replace(/<\/?[^>]+(>|$)/g, '')
  if (strippedValue.length > rule.max) {
    return callback(new Error(i18n.t('validation.maxRules.text', { max: rule.max })))
  }
  return callback()
}

// 引入 CSS 驗證器

// CSS 語法驗證函數（符合 Element UI 驗證格式）
export function checkCssSyntax (rule, value, callback) {
  if (!value || typeof value !== 'string' || !value.trim()) {
    return callback()
  }

  const result = CssValidator.validateSyntax(value)
  if (!result.isValid) {
    const errorMessage = result.errors[0]?.message || 'CSS 語法錯誤'
    return callback(new Error(errorMessage))
  }
  return callback()
}

// CSS 安全性驗證函數
export function checkCssSecurity (rule, value, callback) {
  if (!value || typeof value !== 'string' || !value.trim()) {
    return callback()
  }

  const result = CssValidator.validateSecurity(value)
  if (!result.isValid) {
    const errorMessage = result.issues[0]?.message || 'CSS 安全性問題'
    return callback(new Error(errorMessage))
  }
  return callback()
}

// CSS 完整驗證函數（語法 + 安全性）
export function checkCssComplete (rule, value, callback) {
  if (!value || typeof value !== 'string' || !value.trim()) {
    return callback()
  }

  const result = CssValidator.validate(value)
  if (!result.isValid) {
    const errorMessage = CssValidator.formatErrorMessage(result)
    return callback(new Error(errorMessage))
  }
  return callback()
}

// CSS 驗證規則（符合 Element UI 格式）
export const cssSyntaxRules = () => {
  return {
    validator: checkCssSyntax,
    trigger: ['blur', 'change'],
  }
}

export const cssSecurityRules = () => {
  return {
    validator: checkCssSecurity,
    trigger: ['blur', 'change'],
  }
}

export const cssCompleteRules = () => {
  return {
    validator: checkCssComplete,
    trigger: ['blur', 'change'],
  }
}

// 手機條碼格式驗證（/XXXXXXX, 7碼大寫英數+特殊符號）
export const mobileCarrierFormatRules = (message) => {
  const validator = (rule, value, callback) => {
    if (!/^\/[0-9A-Z.+-]{7}$/.test(value)) {
      return callback(message || '手機條碼格式錯誤')
    }
    return callback()
  }
  return [{ validator, trigger: 'blur' }]
}

// 自然人憑證格式驗證（2碼大寫英文 + 14碼數字）
export const citizenCertificateFormatRules = (message) => {
  const validator = (rule, value, callback) => {
    if (!/^[A-Z]{2}\d{14}$/.test(value)) {
      return callback(message || '自然人憑證格式錯誤')
    }
    return callback()
  }
  return [{ validator, trigger: 'blur' }]
}

// 手機條碼後端驗證（BDV = Barcode Device Verification）
export const mobileCarrierBDVRules = (validateFn) => {
  const asyncValidator = async (rule, value, callback) => {
    if (!value) return callback()
    try {
      const result = await validateFn(value)
      if (!result.valid) {
        callback(result.message || '載具驗證失敗')
      } else {
        callback()
      }
    } catch (e) {
      callback('載具驗證失敗，請稍後再試')
    }
  }
  return [{ asyncValidator, trigger: 'blur' }]
}
